const trackInfo = {
    // 投标多文件检查
    "xsd_all_history": "标书对比查看历史记录",
    "xsd_all_history_check":"标书对比历史记录查看按钮点击",
    "xsd_all_history_export":"标书对比历史记录导出按钮点击",
    "xsd_all_history_del":"标书对比历史记录删除按钮点击",
    "xsd_all_goHome":"标书对比回到首页按钮",
    "xsd_all_start_test":"标书对比开始检查按钮（测试用户）",
    "xsd_all_start_pay":"标书对比开始检查按钮（付费用户）",
    "xsd_word_invest":"标书对比word版点击充值按钮",
    "xsd_word_goHome":"标书对比word回到首页按钮",
    "xsd_word_export":"标书对比word导出",
    "xsd_word_detail":"标书对比word查看详情",
    "xsd_word_restart":"标书对比word重新检查按钮",
    "xsd_word_revoke":"标书对比word取消检查按钮",
    "xsd_pdf_invest":"标书对比pdf版点击充值按钮",
    "xsd_pdf_goHome":"标书对比pdf回到首页按钮",
    "xsd_pdf_export":"标书对比pdf导出",
    "xsd_pdf_detail":"标书对比pdf查看详情",
    "xsd_pdf_restart":"标书对比pdf重新检查按钮",
    "xsd_pdf_revoke":"标书对比pdf取消检查按钮"

}

export default trackInfo;
